
import 'core-js/stable/global-this';
import './Sass/main.sass'
import ModulosPeopleContainer from "./Containers/People/Modules";

function App() {
  return (
    <div className="App">
      <ModulosPeopleContainer />
      {/* <AppRouter /> */}
    </div>
  );
}

export default App;
